import React from "react";
import Modal from "components/common/Modal";
import { ContactInfo } from "./ModalShared";

const NotPosibleToOpenModal = ({ show, onClose }) => {
  return (
    <Modal
      show={show}
      title="Ainda não é possível abrir sua ouvidoria"
      onClose={onClose}
    >
      O seu protocolo de atendimento anterior ainda está no prazo de análise.
      Por favor, aguarde nosso retorno. ou se preferir, entre em contato por
      telefone com a Ouvidoria específica da empresa do seu produto:
      {ContactInfo}
    </Modal>
  );
};

export default NotPosibleToOpenModal;
